import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
export var LoadingProductTileSkeleton = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        "data-test-id": "product-tile-placeholder",
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "100%",
                height: "",
                aspectRatio: "1"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                style: {
                    padding: getSpacing("2x", 0),
                    flex: "1",
                    height: getSpacing(112)
                },
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "75%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 12
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: 64,
                            tabletAndAbove: 40
                        }
                    })
                ]
            })
        ]
    });
};
